import Player from "react-lottie-player/dist/LottiePlayerLight";

import classes from "./BotTypingLoader.module.css";
import path from "./typingLottie.json?url";

function BotTypingLoader() {
    return <Player path={path} className={classes.player} loop play speed={1} />;
}
export default BotTypingLoader;
